export const AppConfig = {
    env: "prod",
    "prod": {
        // developerKey: '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',
        // clientId: "125608681642-qvtunvsha6272svjk8r5j0fg74plhbnp.apps.googleusercontent.com",
        // clientId: "900808419244-ut012up1tsteksjjvcrflf66ducnnfr4.apps.googleusercontent.com",

        developerKey: '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',
        clientId: "1037833999093-fqmc2i9i9jh4u5jbadli3m02s6mkpbcp.apps.googleusercontent.com",
        scope: [
            'profile',
            'email',
            'https://www.googleapis.com/auth/drive'//insert scope here
        ].join(' '),
        baseUrl: ""
    },
}